import React, { ReactElement } from "react";
import Modal from "../modal/Modal";
import MotiveringTextInput from "./MotiveringTextInput";

type ModalProps = {
  name: string;
  title?: string;
  afwijkendeKeuze?: boolean;
  closeModal?: () => void;
};

const MotiveringTextInputModal = ({ name, title, afwijkendeKeuze, closeModal }: ModalProps): ReactElement => {
  return (
    <>
      <Modal
        title={title}
        body={
          <MotiveringTextInput
            name={name}
            afwijkendeKeuze={!!afwijkendeKeuze}
            title={title}
            rows={15}
            withModal={false}
          />
        }
        onCancelClick={closeModal}
        noEditableData={true}
      />
    </>
  );
};

MotiveringTextInputModal.displayName = "Modal";

export default MotiveringTextInputModal;
